module.exports = __webpack_public_path__ + "img/protection-shield-bolt.e3707366.svg";